import styled from 'styled-components';

export const Modal = styled.div`
  background-color: ${({ theme }) => theme.colorsInObjects.opacity.dark};
  z-index: 1001;
`;

export const ModalWrapper = styled.div`
  width: ${({ theme }) => theme.width.full};
`;

export const ModalContent = styled.div`
  margin: ${({ theme }) => theme.spacing.s};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.m};
  border-radius: ${({ theme }) => theme.radius.s};
  background: ${({ theme }) => theme.colors.white};

  & img {
    max-height: calc(100dvh - 420px) !important;
    object-fit: contain;
    max-width: 100%;
  }
  .ReactCrop__child-wrapper {
    display: flex;
    justify-content: center;
  }
`;

export const ButtonBlockWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const ImgFullWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
